import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F4F5F766',
    marginBottom: theme.spacing(2),
    padding: '16px 12px',
  },
}));

export default useStyles;
